import { Button } from "@d12labs/ui/button";
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuTrigger,
} from "@d12labs/ui/dropdown-menu";
import { ChevronDown } from "lucide-react";

export type Affiliation = "internal" | "external" | null;

const LABELS: Record<Exclude<Affiliation, null>, string> = {
	internal: "Internal",
	external: "External",
};

/**
 * Internal / External / Unset picker for a speaker's persisted affiliation
 * (D12-63). Used on the Speakers list rows, the tracked-tier cards, and the
 * speaker profile header. Clicks are stopped from propagating because the list
 * rows render inside <Link>s.
 */
export function AffiliationMenu({
	value,
	onSet,
	size = "sm",
}: {
	value: Affiliation;
	onSet: (affiliation: Affiliation) => void;
	size?: "sm" | "default";
}) {
	return (
		<DropdownMenu>
			<DropdownMenuTrigger asChild>
				<Button
					variant="ghost"
					size={size}
					onClick={(e) => {
						e.preventDefault();
						e.stopPropagation();
					}}
				>
					{value ? LABELS[value] : "Affiliation"}
					<ChevronDown className="h-3 w-3" />
				</Button>
			</DropdownMenuTrigger>
			<DropdownMenuContent align="end">
				{(["internal", "external"] as const).map((option) => (
					<DropdownMenuItem
						key={option}
						onClick={(e) => {
							e.preventDefault();
							e.stopPropagation();
							onSet(option);
						}}
					>
						{LABELS[option]}
						{value === option ? <span className="ml-auto text-ink-subtle">✓</span> : null}
					</DropdownMenuItem>
				))}
				<DropdownMenuItem
					onClick={(e) => {
						e.preventDefault();
						e.stopPropagation();
						onSet(null);
					}}
				>
					Unset
				</DropdownMenuItem>
			</DropdownMenuContent>
		</DropdownMenu>
	);
}
